import { Component, OnInit, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { Capacitor } from '@capacitor/core';
import { AlertController, IonRouterOutlet, ModalController, NavController, Platform } from '@ionic/angular';
import { User } from '@shared/models';

import { ReviewComponent } from '../component/review/review.component';
import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-scan',
  templateUrl: './scan.page.html',
  styleUrls: ['./scan.page.scss'],
})
export class ScanPage implements OnInit {
  user: User | null = null;
  scan;
  scanning = false;
  scanSub;
  flash = false;
  canFlash = false;
  lat = '';
  long = '';
  camera = 0; // 0 = rear, 1 = front

  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
    private apiService: ApiService,
    @Optional() private routerOutlet: IonRouterOutlet,
    private modalCtrl: ModalController,
    private platform: Platform,
    private alertCtrl: AlertController,
    private geolocation: Geolocation,
    private navCtrl: NavController,
    private loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.auth.getUser().then((user) => {
      this.user = user;
    });
    if (this.route.snapshot.data['special']) {
      this.scan = this.route.snapshot.data['special'];
    } else {
      this.navCtrl.navigateBack('/tecservice/home');
    }
  }

  ionViewDidEnter() {
    setTimeout(() => {
      (window.document.querySelector('ion-app') as HTMLElement).classList.add('cameraView');
    }, 300);
    this.platform.ready().then(() => {
      if (Capacitor.isNativePlatform()) {
        this.getCurrentLocation();
        this.initScan();
      } else {
        // this.goReview();
      }
    });
  }

  notAuthorized() {
    console.warn('Camera or Accounts permission is not turned on');
    this.navCtrl.back();
  }

  getCurrentLocation() {
    this.geolocation
      .getCurrentPosition()
      .then((resp) => {
        this.lat = resp.coords.latitude + '';
        this.long = resp.coords.longitude + '';
      })
      .catch((error) => {
        console.log('Error getting location', error);
      });
  }

  ionViewDidLeave() {
    (window.document.querySelector('ion-app') as HTMLElement).classList.remove('cameraView');
  }

  close() {
    // this.activated = false;
    setTimeout(async () => {
      const isModalOpened = await this.modalCtrl.getTop();
      if (isModalOpened) {
        this.modalCtrl.dismiss();
      } else if (this.routerOutlet && this.routerOutlet.canGoBack()) {
        this.routerOutlet.pop();
      } else {
        this.navCtrl.navigateBack('/tecservice/home');
      }
    }, 300);
  }

  initScan() {
    this.platform.ready().then(() => {
      this.newScan();
    });
  }

  async newScan() {
    const result = { code: '' };
    this.processScanText(result.code);
  }

  processScanText(text: string) {
    if (this.apiService.isBase64(text)) {
      const aux = window.atob(text).split('|');

      if (!this.scan.business && aux.length === 2 && aux[0] === 'expresotec') {
        // window.alert("Go review expresotec");
        this.goReview('expresotec', aux[1]);
      } else if (!this.scan.business && aux.length === 2) {
        // window.alert("Go review business");
        // this.simpleAlert("Business id", aux[0]);
        this.goReview('business', aux[0]);
      } else if (this.scan.business && this.scan.business.reward_active === 1 && aux.length === 2) {
        // "Go rewards/points"
        this.sendToServer(aux[0], aux[1]).then((data) => {
          if (data) {
            if (this.scan.endpoint === 'points') {
              // Si es acumulación de puntos
              // Abrir encuesta
              this.simpleAlert('Acumulación exitosa', 'Los puntos fueron asignados a su cuenta.', true);
            } else {
              this.simpleAlert(
                'Recompensa validada',
                'Favor de tomar la recompensa, se ha validado exitosamente.',
                true
              );
            }
          }
        });
      } else {
        // this.presentToast("QR inválido");
        this.simpleAlert('QR inválido', 'Código QR ya usado previamente o es incorrecto.', true);
      }
    } else {
      this.simpleAlert('QR inválido', 'Código QR ya usado previamente o es incorrecto.', true);
    }
  }

  async goReview(type: string, id: string) {
    let busId = null;
    let businessId: string | null = id;

    if (type === 'expresotec') {
      busId = id;
      businessId = null;
    }

    const modal = await this.modalCtrl.create({
      component: ReviewComponent,
      componentProps: {
        id: null,
        business_id: businessId,
        answer1: 0,
        bus_id: busId,
        comments: '',
      },
      cssClass: 'modal-fullscreen',
      keyboardClose: true,
      showBackdrop: true,
    });

    return await modal.present();
  }

  sendToServer(qrId: string, businessId: string) {
    return new Promise((resolve) => {
      this.loadingService.present('Validando...');
      // console.log(this.myForm);
      // alert("POST "+this.endpoint+":"+JSON.stringify({user_id: this.user.id, reward_id: this.reward.id, qr: id, point_id: point_id, business_id: id}));
      this.apiService
        .postData('' + this.scan.endpoint, {
          lat: this.lat,
          long: this.long,
          user_id: this.user?.id,
          reward_id: this.scan.reward.id,
          qr: qrId,
          business_id: businessId,
        })
        .then((res) => {
          // console.log(res);
          // alert("POST: "+JSON.stringify(res));
          if (res.success) {
            resolve(res);
          } else {
            if (res.error) {
              this.simpleAlert('Error', res.error, true);
            } else {
              this.simpleAlert('Error', 'No se pudo validar. Favor de contactar administrador.', true);
            }
            resolve(false);
          }
        })
        .catch((err) => {
          this.close();
          resolve(false);
          console.log(JSON.stringify(err));
        })
        .finally(() => {
          this.loadingService.dismiss();
        });
    });
  }

  async simpleAlert(title: string, message: string, closeAfterClick = false) {
    const alert = await this.alertCtrl.create({
      header: title,
      message,
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
            if (closeAfterClick) {
              this.close();
            }
          },
        },
      ],
    });
    alert.present();
  }
}
